import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QltsUserController from "../../../../services/qlts/qlts-user-controller";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {getSchoolId, getSchoolYear} from "../../../../utils/authority";
import StudentController from "../../../../services/system/student/student-controller";
import GradeManager from "../../../../components/Grade";
import ClassRoomController from "../../../../services/data-declaration/class-room-controller";
import CLBRegisterController from "../../../../services/system/clb-register/clb-register-controller";

class ModalEditStudentInCLB extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            clbId: -1,
            classRoomId: -1,
            listStudent: [],
            listClassRoom: [],
            studentName: "",
            studentId: -1,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState(nextProps.item)
        }
    }
    editStudent = () => {
        if (this.state.note == ""){
            toast.warning("Vui lòng nhập chú thích", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let payload = {
                id: this.state.id,
                note: this.state.note,
                state: this.state.state
            }
            CLBRegisterController.edit(payload, res => {
                if (res.success) {
                    toast.success("Cập nhật học sinh thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    });
                    this.props.onHide();
                    this.props.onRefresh()
                } else {
                    toast.warning(res.message[0], {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                }
            })
        }

    }


    render() {
        let {gradeId} = this.state
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Cập nhật trạng thái học sinh ở CLB</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Chọn học sinh(<span  style={{color: "red",}}>*</span>)</label>
                                    <label className="col-6 label-item pl-0">{this.state.studentRes?.fullName}</label>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Ghi chú</label>
                                    <input
                                        placeholder="Ghi chú"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.note}
                                        onChange={(event) => {
                                            this.setState({
                                                note: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Trạng thái</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.state}
                                        onChange={(e) => {
                                            this.state.state = e.target.value;
                                            this.setState({
                                                state: e.target.value,
                                                inEditing: true
                                            })
                                        }}
                                    >
                                        <option value="ACTIVE">Hoạt động</option>
                                        <option value="SCHOOL_CANCEL">Nhà trường hủy</option>
                                        <option value="PARENT_CANCEL">Phụ huynh hủy</option>
                                    </select>
                                </div>

                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.editStudent()}
                                >
                                        <span className='justify-content-center'>
                                            Cập nhật
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalEditStudentInCLB
